module.exports = __webpack_public_path__ + "static/media/final-corner.c17edb33.jpg";